<template>
  <div class="consulta">
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="col-md-12 d-flex justify-content-between align-items-center">
              <span class="name">{{ $cookies.get('username') }}</span>
              <span>
                <router-link class="logout" to="/logout">Tancar sessió <i class="fas fa-sign-out-alt"></i>
                </router-link>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="col-md-12">
        <FormComponent></FormComponent>
      </div>
    </div>
  </div>
</template>

<script>

import FormComponent from './FormComponent.vue'

export default {
  components: {
    FormComponent
  },
  data() {
    return {

    }
  },
  methods: {

  }
}
</script>
